

export const configBall = (size) => {
    
    return {
        
            //Blob main settings
            BLOB_SIZE: size,
            BLOB_DISTANCE: 1100,
            DETALISATION: 110,
            PERSPECTIVE_DISTORTION: 1,
            ROTATION_SPEED: 5,

            //Dot settins
                DOT_SIZE: 1,
                DOT_COLOR: "#929da0",
                
            //Mouse settings				
                MOUSE_DISTANCE_MIN: 20,
                MOUSE_DISTANCE_MAX: 400,
                MOUSE_SENSITIVITY: 1,
                INERTIAL_TIME: 2,
            
            //Shape settins
            
            //Shape main settings
                INITIAL_SHAPE: {
                                    wave1: {amplitude: 0, frequency: 0, phase: 0},
                                    wave2: {amplitude: 0, frequency: 0, phase: 0},
                                    wave3: {amplitude: 0, frequency: 0, phase: 0}
                            },
                USE_MORPHING: true,
                USE_WAVE_MOTION: false,
                USE_WAVE_SWING: false,
            
            //Morphing settings
                MORPHING_AUTOPLAY: true,
                MORPHING_DURATION: 2,
                MORPHING_DELAY: 1,
                MORPHING_TRANSITION_TYPE: "cubic",
                MORPHING_SHAPES: [										
                                    {
                                        wave1: {amplitude: 10.989, frequency: 10, phase: 3.487},
                                        wave2: {amplitude: 8.791, frequency: 10, phase: 1.277},
                                        wave3: {amplitude: 0, frequency: 0, phase: 2.209}
                                    },
                                    {
                                        wave1: {amplitude: 26.374, frequency: 3.791, phase: 0},
                                        wave2: {amplitude: 26.374, frequency: 3.352, phase: 0},
                                        wave3: {amplitude: 26.374, frequency: 0, phase: 0}
                                    },
                                    {
                                        wave1: {amplitude: 83.516, frequency: 3.132, phase: 3.694},
                                        wave2: {amplitude: 72.527, frequency: 0.769, phase: 3.245},
                                        wave3: {amplitude: 34.066, frequency: 2.857, phase: 0}
                                    },
                                    {
                                        wave1: {amplitude: 31.868, frequency: 2.692, phase: 4.074},
                                        wave2: {amplitude: 50.802, frequency: 0, phase: 4.937},
                                        wave3: {amplitude: 50.505, frequency: 1.044, phase: 2.693}
                                    },
                                    {
                                        wave1: {amplitude: 62.637, frequency: 3, phase: 4.315},
                                        wave2: {amplitude: 80.495, frequency: 2.198, phase: 2.279},
                                        wave3: {amplitude: 50, frequency: 2, phase: 5.42}
                                    },
                                    {
                                        wave1: {amplitude: 0, frequency: 0, phase: 0},
                                        wave2: {amplitude: 80.484, frequency: 1.044, phase: 0},
                                        wave3: {amplitude: 80.835, frequency: 0, phase: 4.695}
                                    },
                                    {
                                        wave1: {amplitude: 0, frequency: 0, phase: 0},
                                        wave2: {amplitude: 0, frequency: 0, phase: 0},
                                        wave3: {amplitude: 0, frequency: 0, phase: 0}
                                    }
                ]
    }
                         
}